import styled from "styled-components";

export const InvoiceReversalContainer = styled.div`
  .invoice-reversal-message {
    margin-bottom: 32px;
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .MuiInputAdornment-root {
    opacity: 0.5;
  }
  .comments {
    margin-top: 16px;
  }
`;
